// extracted by mini-css-extract-plugin
module.exports = {"summary":"summary-module--summary--1umgP"};